import { E2E_TEST_FUNNEL_ENABLED } from "@/constants/env";
import { FlowTypes } from "@/utils/providers/types";

/** Same entry as Both/Friends: first screen is QUESTIONS (see getInitComponent). */
export const shouldE2ETestFunnelStartWithQuestions = (flowType: FlowTypes | null): boolean =>
    E2E_TEST_FUNNEL_ENABLED && flowType === FlowTypes.E2ETestFunnel;
